import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';

import { ControlValueAccessor } from './../../../shared/interfaces/forms.setup';

import { IErrors } from '../../molecules/input/errors.interface';

export const INPUT_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref no-use-before-declare
    useExisting: forwardRef(() => InputAtomSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-input-atom',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    providers: [
        INPUT_CUSTOM_INPUT_ACCESSOR
    ]
})
export class InputAtomSharedComponent implements ControlValueAccessor {
    // tslint:disable-next-line:no-input-rename
    @Input('value') _value = '';

    @Input() placeholder  = '';
    @Input() inputType = 'text';
    @Input() inputId = '';
    @Input() inputName = '';
    @Input() inputDisabled = false;
    @Input() noBorder = false;

    @Input() errors: Array<IErrors> = [];

    @Output() blur = new EventEmitter();
    @Output() focus = new EventEmitter();

    onChange: any = () => {};
    onTouched: any = () => {};

    get value(): any { return this._value; }
    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    registerOnChange(fn): void {
        this.onChange = fn;
    }

    writeValue(value): void {
        this.value = value;
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    updateValue(event: KeyboardEvent): void {
        this.value = (event.target as HTMLInputElement).value;
    }
}
